import { useCallback, useState } from "react";

import type { AiQuotaPaywallReason as AiQuotaReason } from "@superblocksteam/shared";

import { AiQuotaPaywallModalBase } from "../../../core/ai/AiQuotaPaywallModalBase";

type AiQuotaPaywallModalProps = {
  open: boolean;
  reason: AiQuotaReason | undefined;
  onClose: () => void;
  returnTo?: string;
  titleOverride?: string;
};

export const AiQuotaPaywallModal = ({
  open,
  reason,
  onClose,
  returnTo,
  titleOverride,
}: AiQuotaPaywallModalProps) => {
  return (
    <AiQuotaPaywallModalBase
      open={open}
      reason={reason}
      onClose={onClose}
      analyticsSurface="ui"
      returnTo={returnTo}
      titleOverride={titleOverride}
    />
  );
};

export function useAiQuotaPaywall() {
  const [paywallState, setPaywallState] = useState<{
    open: boolean;
    reason: AiQuotaReason | undefined;
  }>({ open: false, reason: undefined });

  const showPaywall = useCallback((reason: AiQuotaReason | undefined) => {
    setPaywallState({ open: true, reason });
  }, []);

  const closePaywall = useCallback(() => {
    setPaywallState({ open: false, reason: undefined });
  }, []);

  return { paywallState, showPaywall, closePaywall };
}
